import { render, staticRenderFns } from "./ServerSideTable.vue?vue&type=template&id=4dcc27be&"
import script from "./ServerSideTable.vue?vue&type=script&lang=js&"
export * from "./ServerSideTable.vue?vue&type=script&lang=js&"
import style0 from "./ServerSideTable.vue?vue&type=style&index=0&id=4dcc27be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports